import { module as BaseModule } from "modujs";

const SELECTORS = {
  item: "[data-before-after-item]",
  trigger: "[data-before-after-trigger]",
};

const CLASSES = {
  active: "is-active",
};

export default class BeforeAndAfter extends BaseModule {
  init() {
    this.items = this.collectItems();

    if (!this.items.length) {
      return;
    }

    this.attachListeners();
  }

  collectItems() {
    return Array.from(this.el.querySelectorAll(SELECTORS.item))
      .map((item) => {
        const trigger = item.querySelector(SELECTORS.trigger);

        if (!trigger) {
          return null;
        }

        return { item, trigger };
      })
      .filter(Boolean);
  }

  attachListeners() {
    this.items.forEach((entry) => {
      const { trigger } = entry;
      const clickHandler = (event) => this.handleToggle(event, entry);
      const keyHandler = (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.handleToggle(event, entry);
        }
      };

      trigger.addEventListener("click", clickHandler);
      trigger.addEventListener("keydown", keyHandler);
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");

      entry.clickHandler = clickHandler;
      entry.keyHandler = keyHandler;
    });
  }

  detachListeners() {
    this.items.forEach((entry) => {
      const { trigger, clickHandler, keyHandler } = entry;

      if (trigger && clickHandler) {
        trigger.removeEventListener("click", clickHandler);
      }

      if (trigger && keyHandler) {
        trigger.removeEventListener("keydown", keyHandler);
      }

      entry.clickHandler = null;
      entry.keyHandler = null;
    });
  }

  handleToggle(event, entry) {
    const { item } = entry;

    if (!item) {
      return;
    }

    const isActive = item.classList.contains(CLASSES.active);
    item.classList.toggle(CLASSES.active, !isActive);
  }

  destroy() {
    this.detachListeners();
    this.items = [];
  }
}
